import React from "react";
import { useNavigate } from "react-router-dom";
import { Network, Store, HardHat, Building2, ArrowUpRight, Scale, Gavel } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: "distribution-new",
  title: "RESPONSABILITÀ ENTI (231)\xA0",
  description: "DCLegal assiste società ed enti nella predisposizione e aggiornamento di Modelli 231 su misura, offrendo una consulenza mirata e orientata alla prevenzione dei rischi. I Professionisti di DCLegal svolgono il ruolo di Presidente e componente degli OdV.\n\n",
  icon: Network,
  colSpan: "md:col-span-2",
  link: "/Consulenza"
}, {
  id: "franchising",
  title: "PRIVACY E E TUTELA DEI DATI",
  description: "DCLegal si distingue come punto di riferimento per le imprese offrendo consulenza specializzata nell’adeguamento alle normative europee in ambito protezione dei dati e nell’implementazione di strategie efficaci per la tutela della privacy e la sicurezza delle informazioni.",
  icon: Store,
  colSpan: "md:col-span-1",
  link: "/Consulenza"
}, {
  id: "construction",
  title: "INTELLIGENZA ARTIFICIALE (AI)",
  description: "DCLegal offre consulenza all’avanguardia anche in materia di Intelligenza Artificiale, aiutando le aziende a cogliere le opportunità offerte dalle nuove tecnologie nel rispetto della normativa vigente.",
  icon: HardHat,
  colSpan: "md:col-span-1",
  link: "/Consulenza"
}, {
  id: "real-estate",
  title: "DIRITTO CIVILE E CONTRATTUALISTICA",
  description: "Lo Studio DCLegal offre ai propri clienti assistenza continuativa su numerose problematiche di diritto civile ed in particolare in merito alla contrattualistica d’impresa assistendo i clienti nelle diverse fasi di negoziazione, redazione, revisione ed esecuzione di contratti e accordi commerciali.",
  icon: Building2,
  colSpan: "md:col-span-2",
  link: "/Consulenza"
}, {
  id: "compliance",
  title: "ATTIVITÀ GIUDIZIARIA",
  description: "Analisi dei rischi e implementazione di modelli organizzativi per la prevenzione dei reati societari.",
  icon: Scale,
  colSpan: "md:col-span-2",
  link: "/Consulenza"
}, {
  id: "litigation",
  title: "HSE, AUDIT E CERTIFICAZIONI",
  description: "Lo Studio DCLegal, attraverso la partnership con la società di consulenza Development Compliance Partner S.r.l., è in grado di assistere i propri clienti negli adempimenti in materia di HSE, nella esecuzione di audit e nel percorso volto all'ottenimento di certificazioni.\n\n",
  icon: Gavel,
  colSpan: "md:col-span-1",
  link: "/Consulenza"
}];
export default function EccellenzaContrattuale() {
  const navigate = useNavigate();
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}